import { Component } from '@angular/core';
import { CanActivateFn, Routes } from '@angular/router';
import { Viewer } from './viewer/viewer';

const redirectToTreantly: CanActivateFn = () => {
  window.location.href = 'https://treantly.com/';
  return false;
};

@Component({ template: '', standalone: true })
class EmptyComponent {}

export const routes: Routes = [
  { path: ':clientCode/:approverId/:token', component: Viewer },
  { path: '**', canActivate: [redirectToTreantly], component: EmptyComponent },
];
